"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = exports.ESprayRecommendation = void 0;
var ESprayRecommendation;
(function (ESprayRecommendation) {
    ESprayRecommendation["IDEAL"] = "IDEAL";
    ESprayRecommendation["AVOID"] = "AVOID";
    ESprayRecommendation["DO_NOT"] = "DO_NOT";
})(ESprayRecommendation || (exports.ESprayRecommendation = ESprayRecommendation = {}));
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    sprayConditions: _aggregation_helpers_1.dailyOrHourlyOnlyAggregationIntervalHelper,
};
//# sourceMappingURL=spray_conditions.js.map